export const ALLOWED_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.in',
  'ymail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'zoho.com',
  'gmx.com',
  'mail.com',
  'yandex.com',
  'rediffmail.com',
  'in.com',
  'indiatimes.com',
];

const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export function validateStudentEmail(email) {
  if (!email || email.trim() === '') return 'Email is required';
  const trimmed = email.trim().toLowerCase();
  if (!EMAIL_REGEX.test(trimmed)) {
    return 'Invalid email format. Please enter a valid email address (e.g., example@gmail.com)';
  }
  const domain = trimmed.split('@')[1];
  if (!ALLOWED_EMAIL_DOMAINS.includes(domain)) {
    return 'Please use a valid email from a known provider (e.g., example@gmail.com)';
  }
  return null;
}
